import {Platform, TextStyle} from 'react-native';

export interface ITypography {
  interBold: object;
  interSemiBold: object;
  interMedium: object;
  interRegular: object;
  mulishBold: object;
  mulishSemibold: object;
  mulishMedium: object;
  mulishRegular: object;
  mulishLight: object;
  notoSansBold: object;
  notoSansSemibold: object;
  notoSansMedium: object;
  notoSansRegular: object;
  notoSansLight: object;
  robotoBold: object;
  robotoMedium: object;
  robotoRegular: object;
  robotoLight: object;
  poppinsRegular: object;
  poppinsMedium: object;
  poppinsSemiBold: object;
  poppinsBold: object;
  mitr: object;
}

export const light = {
  interBold: {
    fontFamily: Platform.OS === 'web' ? 'Inter' : 'Inter-Bold',
    fontWeight: '700',
  },
  interSemiBold: {
    fontFamily: Platform.OS === 'web' ? 'Inter' : 'Inter-SemiBold',
    fontWeight: '600',
  },
  interMedium: {
    fontFamily: Platform.OS === 'web' ? 'Inter' : 'Inter-Medium',
    fontWeight: '500',
  },
  interRegular: {
    fontFamily: Platform.OS === 'web' ? 'Inter' : 'Inter-Regular',
    fontWeight: '400',
  },
  interLight: {
    fontFamily: Platform.OS === 'web' ? 'Inter' : 'Inter-Light',
    fontWeight: '300',
  },
  mulishBold: {
    fontFamily: Platform.OS === 'web' ? 'Mulish' : 'Mulish-Bold',
    fontWeight: '700',
  },
  mulishSemibold: {
    fontFamily: Platform.OS === 'web' ? 'Mulish' : 'Mulish-SemiBold',
    fontWeight: '600',
  },
  mulishMedium: {
    fontFamily: Platform.OS === 'web' ? 'Mulish' : 'Mulish-Medium',
    fontWeight: '500',
  },
  mulishRegular: {
    fontFamily: Platform.OS === 'web' ? 'Mulish' : 'Mulish-Regular',
    fontWeight: '400',
  },
  mulishLight: {
    fontFamily: Platform.OS === 'web' ? 'Mulish' : 'Mulish-Light',
    fontWeight: '300',
  },
  notoSansBold: {
    fontFamily: Platform.OS === 'web' ? 'Noto Sans' : 'NotoSans-Bold',
    fontWeight: '700',
  },
  notoSansSemibold: {
    fontFamily: Platform.OS === 'web' ? 'Noto Sans' : 'NotoSans-SemiBold',
    fontWeight: '600',
  },
  notoSansMedium: {
    fontFamily: Platform.OS === 'web' ? 'Noto Sans' : 'NotoSans-Medium',
    fontWeight: '500',
  },
  notoSansRegular: {
    fontFamily: Platform.OS === 'web' ? 'Noto Sans' : 'NotoSans-Regular',
    fontWeight: '400',
  },
  notoSansLight: {
    fontFamily: Platform.OS === 'web' ? 'Noto Sans' : 'NotoSans-Light',
    fontWeight: '300',
  },
  robotoBold: {
    fontFamily: Platform.OS === 'web' ? 'Roboto' : 'Roboto-Bold',
    fontWeight: '700',
  },
  robotoMedium: {
    fontFamily: Platform.OS === 'web' ? 'Roboto' : 'Roboto-Medium',
    fontWeight: '500',
  },
  robotoRegular: {
    fontFamily: Platform.OS === 'web' ? 'Roboto' : 'Roboto-Regular',
    fontWeight: '400',
  },
  robotoLight: {
    fontFamily: Platform.OS === 'web' ? 'Roboto' : 'Roboto-Light',
    fontWeight: '300',
  },
  poppinsRegular: {
    fontFamily: Platform.OS === 'web' ? 'Poppins' : 'Poppins-Regular',
    fontWeight: '400',
  },
  poppinsMedium: {
    fontFamily: Platform.OS === 'web' ? 'Poppins' : 'Poppins-Medium',
    fontWeight: '500',
  },
  poppinsSemiBold: {
    fontFamily: Platform.OS === 'web' ? 'Poppins' : 'Poppins-SemiBold',
    fontWeight: '600',
  },
  poppinsBold: {
    fontFamily: Platform.OS === 'web' ? 'Poppins' : 'Poppins-Bold',
    fontWeight: '700',
  },
  mitr: {
    fontFamily: Platform.OS === 'web' && 'Mitr',
  },
};

export const dark = {
  interBold: {
    fontFamily: Platform.OS === 'web' ? 'Inter' : 'Inter-Bold',
    fontWeight: '700',
  },
  interSemiBold: {
    fontFamily: Platform.OS === 'web' ? 'Inter' : 'Inter-SemiBold',
    fontWeight: '600',
  },
  interMedium: {
    fontFamily: Platform.OS === 'web' ? 'Inter' : 'Inter-Medium',
    fontWeight: '500',
  },
  interRegular: {
    fontFamily: Platform.OS === 'web' ? 'Inter' : 'Inter-Regular',
    fontWeight: '400',
  },
  interLight: {
    fontFamily: Platform.OS === 'web' ? 'Inter' : 'Inter-Light',
    fontWeight: '300',
  },
  mulishBold: {
    fontFamily: Platform.OS === 'web' ? 'Mulish' : 'Mulish-Bold',
    fontWeight: '700',
  },
  mulishSemibold: {
    fontFamily: Platform.OS === 'web' ? 'Mulish' : 'Mulish-SemiBold',
    fontWeight: '600',
  },
  mulishMedium: {
    fontFamily: Platform.OS === 'web' ? 'Mulish' : 'Mulish-Medium',
    fontWeight: '500',
  },
  mulishRegular: {
    fontFamily: Platform.OS === 'web' ? 'Mulish' : 'Mulish-Regular',
    fontWeight: '400',
  },
  mulishLight: {
    fontFamily: Platform.OS === 'web' ? 'Mulish' : 'Mulish-Light',
    fontWeight: '300',
  },
  notoSansBold: {
    fontFamily: Platform.OS === 'web' ? 'Noto Sans' : 'NotoSans-Bold',
    fontWeight: '700',
  },
  notoSansSemibold: {
    fontFamily: Platform.OS === 'web' ? 'Noto Sans' : 'NotoSans-SemiBold',
    fontWeight: '600',
  },
  notoSansMedium: {
    fontFamily: Platform.OS === 'web' ? 'Noto Sans' : 'NotoSans-Medium',
    fontWeight: '500',
  },
  notoSansRegular: {
    fontFamily: Platform.OS === 'web' ? 'Noto Sans' : 'NotoSans-Regular',
    fontWeight: '400',
  },
  notoSansLight: {
    fontFamily: Platform.OS === 'web' ? 'Noto Sans' : 'NotoSans-Light',
    fontWeight: '300',
  },
  robotoBold: {
    fontFamily: Platform.OS === 'web' ? 'Roboto' : 'Roboto-Bold',
    fontWeight: '700',
  },
  robotoMedium: {
    fontFamily: Platform.OS === 'web' ? 'Roboto' : 'Roboto-Medium',
    fontWeight: '500',
  },
  robotoRegular: {
    fontFamily: Platform.OS === 'web' ? 'Roboto' : 'Roboto-Regular',
    fontWeight: '400',
  },
  robotoLight: {
    fontFamily: Platform.OS === 'web' ? 'Roboto' : 'Roboto-Light',
    fontWeight: '300',
  },
  poppinsRegular: {
    fontFamily: Platform.OS === 'web' ? 'Poppins' : 'Poppins-Regular',
    fontWeight: '400',
  },
  poppinsMedium: {
    fontFamily: Platform.OS === 'web' ? 'Poppins' : 'Poppins-Medium',
    fontWeight: '500',
  },
  poppinsSemiBold: {
    fontFamily: Platform.OS === 'web' ? 'Poppins' : 'Poppins-SemiBold',
    fontWeight: '600',
  },
  poppinsBold: {
    fontFamily: Platform.OS === 'web' ? 'Poppins' : 'Poppins-Bold',
    fontWeight: '700',
  },
  mitr: {
    fontFamily: Platform.OS === 'web' && 'Mitr',
  },
};
